export default __webpack_public_path__ + "static/media/icn-drive-time-without-consumption-with-ecoroll.5c04cfb3.svg";